import React, { useEffect, useRef, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import configurationManagementService from "@services/configuationManagement.service";
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { BlockUI } from 'primereact/blockui';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Calendar } from 'primereact/calendar';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { error } from "highcharts";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
export default function Tracker() {
  const toast = useRef(null);
  const [blocked, setBlocked] = useState(false);
  const [file, setFile] = useState();

  const fileUploader = useRef(null);
  const [update, setUpdate] = useState(true);
  const [crNumber, setCrNumber] = useState();
  const [lastState, setLastState] = useState();



  useEffect(() => {
    configurationManagementService.Post("/irancell/tracker/getList", {}).then((result) => {
      setReportsList(result.data)
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'error', detail: error.message });
    })
  }, [update]);

  const onDeleteReport = (row) => {
    configurationManagementService.Post("/irancell/tracker/delete", { crnumber: row.crnumber }).then((response) => {
      toast.current.show({ severity: 'info', summary: 'Info', detail: 'Success' });
      setUpdate(!update);
    }).catch((err) => {
      console.log(err)
      toast.current.show({ severity: 'error', summary: 'error', detail: err.message });
    })

  }
  const onDownload = (row) => {
    setBlocked(true);
    configurationManagementService.PostBlob("/irancell/tracker/download", { id: row._id }).then((response) => {
      const href = URL.createObjectURL(new Blob([response.data]));

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', row.crnumber + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      setBlocked(false);
    }).catch((err) => {
      toast.current.show({ severity: 'error', summary: 'error', detail: 'Download Fails' });
      setBlocked(false);
    })
  }

  const exportTemplateDownload = (rowData) => {
    return (
      <Button icon="pi pi-download" onClick={() => onDownload(rowData)} size="small" />
    );
  };
  const reportTemplate = (rowData) => {
    return (
      <Button icon="pi pi-file-excel" onClick={() => onDownload(rowData)} size="small" />
    );
  };
  const startTemplate = (rowData) => {
    return (
      <Button icon="pi pi-wrench" label="Start" onClick={(e) => { setCrNumber(rowData.crnumber); setLastState("Implementing"); op.current.toggle(e); }} size="small" />
    );
  };
  const rejectTemplate = (rowData) => {
    return (
      <Button icon="pi pi-thumbs-down" onClick={(e) => { setCrNumber(rowData.crnumber); setLastState("Rejected"); op.current.toggle(e); }} label="Reject" severity="danger" size="small" />
    );
  };
  const failTemplate = (rowData) => {
    return (
      <Button icon="pi pi-times" label="Fail" onClick={(e) => { setCrNumber(rowData.crnumber); setLastState("Failed"); op.current.toggle(e); }} severity="danger" size="small" />
    );
  };
  const fllowTemplate = (rowData) => {
    return (
      <Button icon="pi pi-align-justify" label="History" onClick={(e) => { setCrNumber(rowData.crnumber); op2.current.toggle(e); }} severity="secondary" size="small" />
    );
  };
  const exportTemplate = (rowData) => {
    return (
      <Button icon="pi pi-times" onClick={() => onDeleteReport(rowData)} className="p-button-rounded p-button-danger p-button-text" />
    );
  };
  // ImplementDoneTemplate
  const implementDoneTemplate = (rowData) => {
    return (
      <Button icon="pi pi-thumbs-up" label="Done" onClick={(e) => { setCrNumber(rowData.crnumber); setLastState("Done"); op.current.toggle(e); }} size="small" />
    );
  };
  const items = [
    { name: 'Low', value: 'Low' },
    { name: 'Medium', value: 'Medium' },
    { name: 'High', value: 'High' }
  ];
  const [crnumber, setCrnumber] = useState();
  const [deadline, setDeadline] = useState();
  const [comment, setComment] = useState();
  const [commentUpdate, setCommentUpdate] = useState();
  const [priority, setPriority] = useState();
  const [reportsList, setReportsList] = useState([]);
  const [histories, setHistories] = useState();
  const dateBodyTemplate = (row) => {
    if ("lastUpdate" in row) {
      return new Date(row.lastUpdate).toLocaleDateString();
    }
    if ("date" in row) {
      return new Date(row.date).toLocaleDateString();
    }
    return "";
  };
  const op = useRef(null);
  const op2 = useRef(null);

  const Save = () => {
    if (commentUpdate) {
      setBlocked(true);
      configurationManagementService.Post("/irancell/tracker/update", { crnumber: crNumber, updateQuery: { lastStatus: lastState }, comment: commentUpdate, }).then((response) => {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Success' });
        setUpdate(!update);
        setBlocked(false);
        setCommentUpdate("");
        op.current.hide();
      }).catch((err) => {
        toast.current.show({ severity: 'error', summary: 'error', detail: err.message });
        setBlocked(false);
      })
    } else {
      toast.current.show({ severity: 'error', summary: 'error', detail: "Comment is mandatory" });
    }

  }
  const upload = () => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("crnumber", crnumber);
    formData.append("deadline", deadline);
    formData.append("comment", comment);
    formData.append("priority", priority);
    setBlocked(true);
    configurationManagementService.PostForm("/irancell/tracker/Add", formData).then((result) => {
      toast.current.show({ severity: 'info', summary: 'Info', detail: 'Success' });
      fileUploader.current.clear();
      setBlocked(false);
      setUpdate(!update);
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'error', detail: error.message });
      setBlocked(false);
    });
  }

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    crnumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastUser: { value: null, matchMode: FilterMatchMode.CONTAINS },
    priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
    lastUpdate: { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return (
      ""
    );
  };
  const header = renderHeader();
  return (
    <div className="card">
      <BlockUI blocked={blocked}>
        <div className="flex justify-content-end mt-3">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
          </span>
        </div>
        <TabView className="m-4">
          <TabPanel leftIcon="pi pi-gift mr-2" className="mr-2 ml-2" header={"All(" + reportsList.length + ")"}>
            <DataTable dataKey="crnumber" paginator rows={20}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']}
              value={reportsList}>
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column field="lastStatus" header="Last Status"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              <Column body={fllowTemplate}  ></Column>
            </DataTable>
          </TabPanel>
          <TabPanel leftIcon="pi pi-cloud-upload mr-2" className="mr-2 ml-2" header="Upload">
            <div className="space-y-12">
              <div className="border-b border-gray-900/10 pb-12">
                <h2 className="text-base font-semibold leading-7 text-gray-900">CM tracker</h2>
                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div className="sm:col-span-4">
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                      CR Number
                    </label>
                    <div className="mt-2">
                      <InputText id="username" value={crnumber} onChange={(e) => setCrnumber(e.target.value)} aria-describedby="username-help" />DeadLine :  <Calendar value={deadline} onChange={(e) => setDeadline(e.value)} showIcon />
                    </div>
                  </div>
                  <div className="sm:col-span-4">
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                      File
                    </label>
                    <div className="mt-2">
                      <FileUpload mode="basic" ref={fileUploader} name="demo[]" onSelect={(e) => setFile(e.files[0])} maxFileSize={150000000} emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
                    </div>
                  </div>
                  <div className="sm:col-span-4">
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                      Priority
                    </label>
                    <div className="mt-2">
                      <SelectButton value={priority} onChange={(e) => setPriority(e.value)} optionLabel="name" options={items} />
                    </div>
                  </div>
                  <div className="col-span-full">
                    <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                      Comment
                    </label>
                    <div className="mt-2">
                      <textarea value={comment} onChange={(e) => setComment(e.target.value)}
                        id="about"
                        name="about"
                        rows={3}
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        defaultValue={''}
                      />
                    </div>
                    <p className="mt-3 text-sm leading-6 text-gray-600">Write a few sentences about CR.</p>
                  </div>
                  <div className="sm:col-span-4">
                    <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                    </label>
                    <div className="mt-2">
                      <Button label="Upload" onClick={(e) => upload()} raised />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </TabPanel>
          <TabPanel leftIcon="pi pi-gift mr-2" className="mr-2 ml-2" header={"New(" + reportsList.filter(q => q.lastStatus === "New").length + ")"}>
            <DataTable value={reportsList.filter(q => q.lastStatus === "New")}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']}>
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              <Column body={startTemplate}  ></Column>
              <Column body={rejectTemplate}  ></Column>
              <Column body={fllowTemplate}  ></Column>
            </DataTable>
          </TabPanel>
          <TabPanel leftIcon="pi pi-wrench mr-2" className="mr-2 ml-2" header={"Implementing(" + reportsList.filter(q => q.lastStatus === "Implementing").length + ")"}>
            <DataTable value={reportsList.filter(q => q.lastStatus === "Implementing")}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']} >
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              <Column body={implementDoneTemplate}  ></Column>
              <Column body={failTemplate}  ></Column>
              <Column body={rejectTemplate}  ></Column>
              <Column body={fllowTemplate}  ></Column>
            </DataTable>
          </TabPanel>
          <TabPanel leftIcon="pi pi-thumbs-up mr-2" className="mr-2 ml-2" header={"Done(" + reportsList.filter(q => q.lastStatus === "Done").length + ")"}>
            <DataTable value={reportsList.filter(q => q.lastStatus === "Done")}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']} >
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              {/* <Column body={implementDoneTemplate}  ></Column>
              <Column body={failTemplate}  ></Column>
              <Column body={rejectTemplate}  ></Column> */}
              <Column body={fllowTemplate}  ></Column>
            </DataTable>
          </TabPanel>
          <TabPanel leftIcon="pi pi-thumbs-down mr-2" className="mr-2 ml-2" header={"Reject(" + reportsList.filter(q => q.lastStatus === "Rejected").length + ")"}>
            <DataTable value={reportsList.filter(q => q.lastStatus === "Rejected")}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']}>
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              {/* <Column body={implementDoneTemplate}  ></Column>
              <Column body={failTemplate}  ></Column>
              <Column body={rejectTemplate}  ></Column> */}
              <Column body={fllowTemplate}  ></Column>

            </DataTable>
          </TabPanel>
          <TabPanel leftIcon="pi pi-times mr-2" className="mr-2 ml-2" header={"Fail(" + reportsList.filter(q => q.lastStatus === "Failed").length + ")"}>
            <DataTable value={reportsList.filter(q => q.lastStatus === "Failed")}
              filters={filters}
              globalFilterFields={['crnumber', 'lastUser', 'priority', 'lastUpdate', 'lastStatus']} >
              <Column body={exportTemplate}  ></Column>
              <Column field="crnumber" header="CR Number"></Column>
              <Column field="lastUser" header="Changed By"></Column>
              <Column field="priority" header="Priority"></Column>
              <Column body={dateBodyTemplate} header="Last Update"></Column>
              <Column body={exportTemplateDownload}  ></Column>
              {/* <Column body={implementDoneTemplate}  ></Column>
              <Column body={failTemplate}  ></Column>
              <Column body={rejectTemplate}  ></Column> */}
              <Column body={fllowTemplate}  ></Column>

            </DataTable>
          </TabPanel>
        </TabView></BlockUI>
      <OverlayPanel ref={op}>
        <div className="space-y-12">
          <div className="pb-12">

            <div className="col-span-full">
              <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                Comment
              </label>
              <div className="mt-2">
                <textarea value={commentUpdate} onChange={(e) => setCommentUpdate(e.target.value)}
                  id="about"
                  name="about"
                  rows={3}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  defaultValue={''}
                />
              </div>
              <p className="mt-3 text-sm leading-6 text-gray-600">Write a few sentences about CR.</p>
            </div>
            <div className="sm:col-span-4">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
              </label>
              <div className="mt-2">
                <Button label="Save" onClick={(e) => Save()} raised />
              </div>
            </div>
          </div>
        </div>
      </OverlayPanel>
      <OverlayPanel ref={op2}>
        <DataTable value={(reportsList.filter(q => q.crnumber === crNumber).length === 0 ? [] : reportsList.filter(q => q.crnumber === crNumber)[0].changes)} >
          <Column field="user" header="user"></Column>
          <Column field="comment" header="comment"></Column>
          <Column field="action" header="action"></Column>
          <Column body={dateBodyTemplate} header="date"></Column>
        </DataTable>
      </OverlayPanel>
      <Toast ref={toast} />
    </div>

  )
}
